import { SwitchType } from "@components/inputs/switch/Switch";
import SmartField from "@components/smart/smartField";
import { ISmartFieldBlur, ISmartFieldChange } from "@components/smart/smartField/SmartField";
import BindingContext from "@odata/BindingContext";
import {
    IPrRetirementSavingsProductEntity,
    PrRetirementSavingsCompanyEntity,
    PrRetirementSavingsProductEntity
} from "@odata/GeneratedEntityTypes";
import { CountryCode, PrRetirementSavingsTypeCode } from "@odata/GeneratedEnums";
import { getEnumValues } from "@odata/GeneratedEnums.utils";
import { getBankAccountsFieldBaseDef } from "@pages/banks/bankAccounts/BankAccounts.utils";
import {
    SavingsBody,
    SavingsButton,
    SavingsFields,
    SavingsHeader,
    SavingsLine,
    SavingsRow,
    SavingsText
} from "@pages/payroll/retirementSavingsCompany/RetirementSavingsCompany.styled";
import { isNotDefined } from "@utils/general";
import React from 'react';

import TestIds from "../../../testIds";
import { FormStorage } from "../../../views/formView/FormStorage";

interface IProps {
    storage: FormStorage;
    onChange: (args: ISmartFieldChange) => void;
    onBlur: (args: ISmartFieldBlur) => Promise<void>;
}

interface IState {
}

export class SavingsTypeForm extends React.Component<IProps, IState> {
    isChecked = (type: PrRetirementSavingsTypeCode) => {
        const entity = this.props.storage.data.entity;
        return !!(entity.Products || []).find((product: IPrRetirementSavingsProductEntity) => product.Type?.Code === type);
    }

    getTypeIndex = (code: PrRetirementSavingsTypeCode) => {
        return Object.values(PrRetirementSavingsTypeCode).indexOf(code);
    }

    handleRowCheck = (type: PrRetirementSavingsTypeCode, checked: boolean) => {
        const entity = this.props.storage.data.entity;
        if (this.isChecked(type)) {
            entity.Products = entity.Products?.filter((product: IPrRetirementSavingsProductEntity) => product.Type?.Code !== type) ?? [];
        } else {
            entity.Products = [...entity.Products || [], ...[{
                BankAccount: {
                    Country: {
                        Code: CountryCode.CzechRepublic
                    }
                },
                Type: {
                    Code: type
                },
                [BindingContext.NEW_ENTITY_ID_PROP]: this.getTypeIndex(type)
            }]];
        }

        this.forceUpdate();
    }

    renderFields = (type: PrRetirementSavingsTypeCode) => {
        const BaseBankFieldDefs = getBankAccountsFieldBaseDef();
        const row = (this.props.storage.data.entity.Products || []).find((product: IPrRetirementSavingsProductEntity) => product.Type?.Code === type);
        const id = row.Id ?? row[BindingContext.NEW_ENTITY_ID_PROP];
        const rootBc = this.props.storage.data.bindingContext.navigate(PrRetirementSavingsCompanyEntity.Products);
        const lineBc = rootBc.addKey(id, isNotDefined(row.Id));
        const fields = Object.keys(BaseBankFieldDefs);
        return fields.map((key: string, i: number) => {
            return (
                <SmartField
                    bindingContext={lineBc.navigate(`${PrRetirementSavingsProductEntity.BankAccount}/${key}`)}
                    storage={this.props.storage}
                    onChange={this.props.onChange}
                    onBlur={this.props.onBlur}
                    fieldProps={{
                        isSharpRight: i !== fields.length -1,
                        isSharpLeft: i !== 0
                    }}

                >

                </SmartField>
            );
        });
    }

    renderContent = (type: PrRetirementSavingsTypeCode) => {
        const isExpanded = this.isChecked(type);
        return (
            <>
                <SavingsHeader>
                    <SavingsText>{this.props.storage.t(`RetirementSavingsCompany:Savings.${type}`)}</SavingsText>
                    <SavingsButton
                        type={SwitchType.YesNo}
                        checked={isExpanded}
                        onChange={this.handleRowCheck.bind(this, type)} />
                    <SavingsLine/>
                </SavingsHeader>
                {isExpanded &&
                    <SavingsFields>
                        {this.renderFields(type)}
                    </SavingsFields>
                }

            </>
        );
    }

    render() {
        const types = getEnumValues<PrRetirementSavingsTypeCode>("PrRetirementSavingsType");
        return (
            <SavingsBody>
                {types.map((type: PrRetirementSavingsTypeCode) => {
                    return (
                        <SavingsRow data-testid={TestIds.RetirementSavingsRow} data-id={type}>
                            {this.renderContent(type)}
                        </SavingsRow>);
                })}
            </SavingsBody>
        );
    }
}